import { useI18n } from "@/i18n/I18nContext";

export const WHATSAPP_NUMBER = "+237659112962";
export const whatsappUrl = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.07c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.7.62.71.23 1.36.2 1.87.12.57-.08 1.75-.71 2-1.4.25-.7.25-1.29.17-1.4-.07-.13-.27-.2-.57-.35M12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.4 9.4 0 0 1-1.44-5.02c0-5.2 4.23-9.43 9.44-9.43a9.4 9.4 0 0 1 9.43 9.44c0 5.2-4.23 9.43-9.44 9.43m8.03-17.46A11.27 11.27 0 0 0 12.05.72C5.8.72.7 5.8.7 12.06c0 2 .52 3.95 1.52 5.67L.6 23.28l5.68-1.49a11.3 11.3 0 0 0 5.77 1.47c6.25 0 11.34-5.09 11.34-11.34 0-3.03-1.18-5.88-3.32-8.02" />
  </svg>
);

export const ContactWhatsApp = ({ testid = "contact-whatsapp" }) => {
  const { t } = useI18n();
  return (
    <section className="surface flex flex-wrap items-center gap-4 p-5" data-testid={testid}>
      <div className="min-w-[12rem] flex-1">
        <p className="font-display font-bold">{t("contact.title")}</p>
        <p className="text-sm text-slate-400">{t("contact.text")}</p>
      </div>
      <a href={whatsappUrl(t("contact.message"))} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-btn`}
        aria-label={t("contact.cta")} title={t("contact.cta")}
        className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#25D366] text-white transition-transform hover:scale-105">
        <WhatsAppIcon className="h-7 w-7" />
      </a>
    </section>
  );
};
